export default "__VITE_ASSET__DFBnD2tf__"